import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { OktaAuthService } from "@okta/okta-angular";

@Injectable()
export class LoggedInUserGuard implements CanActivate {
  constructor(
    private router: Router,
    private oktaAuthService: OktaAuthService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // user is not authenticated
    if (!(await this.oktaAuthService.isAuthenticated())) {
      return true;
    }

    // user is authenticated hence don't allow user to access the login screen instead navigate to default application page
    // change the default application route
    this.router.navigate(["/personofinterest"]);
    return false;
  }
}
